"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportSchemaValidator = void 0;
const zod_1 = require("zod");
const reportTypesEnum = zod_1.z.enum(['office', 'management', 'creditor', 'teams']);
exports.reportSchemaValidator = zod_1.z.string().refine(value => {
    if (typeof value !== 'string')
        return false;
    const parts = value.split(',');
    return parts.every(part => reportTypesEnum['_def'].values.includes(part.trim()));
});
